import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class AddressDto extends BaseEntityDto {
  name: string;
  address: string;
  postalCode: string;
  city: string;
  province: string;
  country: string;

  toString() {
    const parts = [
      this.name,
      this.address,
      this.postalCode ? `${this.postalCode}` : null,
      this.city,
      this.province,
      this.country,
    ].filter(Boolean);

    return parts.join(", ");
  }
}
